module.exports = __webpack_public_path__ + "img/banner_app.c5d0a3b4.png";